import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { Popover } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { AdministrationStatus } from '../types'
import { getAdministrationStatusDisplay } from '../utils/administrationUtils'

const ADMINISTRATION_STATUSES_FOR_LEGEND: AdministrationStatus[] = [
  AdministrationStatus.GIVEN,
  AdministrationStatus.VERBAL_PROMPT,
  AdministrationStatus.ABSENT,
  AdministrationStatus.OTHER,
  AdministrationStatus.ALREADY_TAKEN,
  // AdministrationStatus.NOT_NEEDED,
  AdministrationStatus.LEFT_OUT,
  // AdministrationStatus.PAUSED,
  AdministrationStatus.NAUSEA_VOMITING,
  AdministrationStatus.DISCONTINUED,
  AdministrationStatus.REFUSED,
  // AdministrationStatus.MISSED,
  AdministrationStatus.REFUSED_DESTROYED
]

const Legend = () => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const theme = useTheme()

  const legendItems = ADMINISTRATION_STATUSES_FOR_LEGEND.map((status) => ({
    status,
    ...getAdministrationStatusDisplay(status)
  }))

  return (
    <Popover
      placement="bottomRight"
      overlayInnerStyle={{
        borderRadius: '9px',
        padding: '10px 16px'
      }}
      content={
        <LegendContent>
          {legendItems.map((item) => (
            <LegendItemContainer key={item.translationKey}>
              <LegendCodeContainer>{item.display}</LegendCodeContainer>
              <Text>{t(item.translationKey)}</Text>
            </LegendItemContainer>
          ))}
        </LegendContent>
      }
    >
      <LegendContainer>
        <QuestionCircleOutlined
          style={{ fontSize: 16, color: theme.color.neutral.color4 }}
        />
        <StyledText level={2}>{t('LEGEND')}</StyledText>
      </LegendContainer>
    </Popover>
  )
}

const LegendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

const LegendContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  min-width: 300px;
`

const LegendItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const LegendCodeContainer = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LegendCode = styled(Text)`
  font-weight: 600;
  color: ${({ theme }) => theme.color.neutral.color3};
`

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

export default Legend
